import { ApiClient } from "lib/utils/client/apiClient";

export const GetAllReports = async ({
  page,
  limit,
  search,
}: {
  page: number;
  limit: number;
  search?: string;
}) => {
  const payload: any = { page, limit };
  if (search && search.trim().length > 0) payload.search = search.trim();
  return ApiClient("/tickets/findAll", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export const GetReportStats = async () => {
  return ApiClient("/tickets/stats", {
    method: "GET",
  });
}

export const GetAllStaff = async () => {
  return ApiClient(`/staff/all`, {
    method: "GET",
  });
}

export const AssignIssueToProfessional = async (
  reportId: string,
  professionalId: string
) => {
  return ApiClient(`/tickets/${reportId}/assign-staff`, {
    method: "POST",
    body: JSON.stringify({ staffId: professionalId }),
  });
}

export const UpdateReportStatus = async (
  reportId: string,
  status: "open" | "in_progress" | "closed"
) => {
  return ApiClient(`/tickets/${reportId}`, {
    method: "PATCH",
    body: JSON.stringify({ status }),
  });
}